import React from "react"
import grasssvg from "../imgs/grass.svg";

export default function Grass() {
  return <img src={grasssvg} alt="grass here"/>
}
